export default __webpack_public_path__ + "static/media/iphone-overlay.9f906165.png";